<template>
  <div>
    <Alert v-if="isLessLessonsThanPeriodicity(program)" :type="'info'" :icon="'far fa-circle-info'">
      <p class="text-center text-3xl">
        <b>
          <p>
            Your program has topics that have fewer lessons than the number of delivery years
            (e.g. 1 lesson which doesn’t expire for 3 years).  This will make your year to year scheduling vary.
          </p>
        </b>
      </p>
    </Alert>
  </div>
</template>

<script>
import Alert from "@components/UIComponents/Alert";

export default {
  components: { Alert },
  props: {
    program: {
      type: Object,
      required: true,
    },
  },
  methods: {
    isLessLessonsThanPeriodicity(program) {
      const topicList = program.topicList;
      const totalTopicCount = topicList.length;

      let lessThanPeriodicity = 0;
      for (const topic of topicList) {
        if (!topic.lessLessonsThanPeriodicity) {
          continue;
        }
        lessThanPeriodicity += 1;
      }

      const half = totalTopicCount / 2;
      return lessThanPeriodicity > half;
    }
  },
};
</script>

<style lang="scss"></style>
